<dashboardnav>
  <cradua-hierarchy [hierarchys]="hierarchys$ | async" (hierarchy)="onSubmitHierarchy($event)"
    (deleteHierarchyEvent)="onDeleteHierarchy($event)" *ngIf="(isLoadingHierarchy$ | async ) === false">
  </cradua-hierarchy>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingHierarchy$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
